export const finalValues = {
  Email: ['subject', 'email_template_content', 'sender_name', 'from_email_address', 'reply_to_email_address'],
  SMS: ['sms_template_name', 'sms_template_content', 'sms_template_name', 'sms_template_id', 'sender_id', 'purpose'],
  Push: ['push_template_content', 'device_type', 'message_title'],
};
export const targetUser = ['campaign_name','selected_audience'];
export const ScheduleFields = ['schedule_campaign']; 
export const COUNTRY_CODE = "+91";
export const CUSTOMER_ROLEID = 4;